import React from 'react';

import { Grid, Segment } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';

import useStyleRuleSettings from 'components/modules/style-rules/hooks/useStyleRuleSettings/useStyleRuleSettings';

import { StyleRulesSettingsTabProvider } from './SettingsTab.context';
import StyleRulesSettingsLeftNavigationMenu from './components/StyleRulesSettingsLeftNavigationMenu';
import StyleRulesSettingsMainPanel from './components/StyleRulesSettingsMainPanel';
import StyleRulesSettingsTopControls from './components/StyleRulesSettingsTopControls';

import './SettingsTab.scss';

const propTypes = {};

const defaultProps = {};

export default function SettingsTab() {
  const {
    styleRules,
    styleRuleConfigurations,
    currentStyleRuleConfigurations,
    setCurrentStyleRuleConfigurations,
    selectedFolder,
    onSelectFolder,
    onResetFilters,
    selectedStateFilters,
    onSelectStateFilter,
    selectedUnitFilters,
    onSelectUnitFilter,
    localSearchQuery,
    onLocalSearchQueryChange,
    highlightedStyleRule,
    onSelectHighlightedStyleRule,
    getStyleRuleConfigurationsFolderItems,
    getStyleRuleInheritance,
  } = useStyleRuleSettings();

  const contextValue = {
    styleRules,
    styleRuleConfigurations,
    currentStyleRuleConfigurations,
    setCurrentStyleRuleConfigurations,
    selectedFolder,
    onSelectFolder,
    selectedUnitFilters,
    onSelectUnitFilter,
    selectedStateFilters,
    onSelectStateFilter,
    onResetFilters,
    localSearchQuery,
    onLocalSearchQueryChange,
    highlightedStyleRule,
    onSelectHighlightedStyleRule,
    getStyleRuleConfigurationsFolderItems,
    getStyleRuleInheritance,
  };

  const hasHierarchySettings = styleRuleConfigurations.every(
    ({ hierarchy }) => !_isEmpty(hierarchy),
  );

  return (
    <StyleRulesSettingsTabProvider value={contextValue}>
      <div className="settings-tab">
        <Grid>
          {hasHierarchySettings && (
            <Grid.Row className="top-controls-row">
              <Grid.Column width={16}>
                <StyleRulesSettingsTopControls />
              </Grid.Column>
            </Grid.Row>
          )}
          <Grid.Row className="main-panel-row">
            {hasHierarchySettings && (
              <Grid.Column width={4}>
                <Segment>
                  <StyleRulesSettingsLeftNavigationMenu />
                </Segment>
              </Grid.Column>
            )}
            <Grid.Column width={12}>
              <Segment>
                <StyleRulesSettingsMainPanel />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </StyleRulesSettingsTabProvider>
  );
}

SettingsTab.propTypes = propTypes;
SettingsTab.defaultProps = defaultProps;
